// StepActions — presentational. The Back / Save Draft / Continue (or
// "Generate Requirements" on the last step) button row at the bottom of every
// step. All behavior is driven by the props passed from the parent page.
export function StepActions({
  onBack,
  onSaveDraft,
  onNext,
  isLast,
  canContinue,
  submitting,
}: {
  onBack: (() => void) | null
  onSaveDraft: () => void
  onNext: () => void
  isLast: boolean
  canContinue: boolean
  submitting: boolean
}) {
  return (
    <>
      <hr className="step-divider" />
      <div className="step-actions">
        <div className="step-actions-left">
          {onBack && (
            <button type="button" className="step-back" onClick={onBack}>
              Back
            </button>
          )}
        </div>
        <div className="step-actions-right">
          <button type="button" className="btn btn-ghost btn-wizard" onClick={onSaveDraft}>
            Save Draft
          </button>
          <button
            type="button"
            className={`btn btn-molten btn-wizard${isLast ? ' with-spark' : ''}`}
            onClick={onNext}
            disabled={!canContinue || submitting}
          >
            {isLast ? (submitting ? 'Generating…' : 'Generate Requirements') : 'Continue →'}
          </button>
        </div>
      </div>
    </>
  )
}
